import { render } from "./FeaturePanel.vue?vue&type=template&id=644ab108"
import script from "./FeaturePanel.vue?vue&type=script&lang=js"
export * from "./FeaturePanel.vue?vue&type=script&lang=js"

import "./FeaturePanel.vue?vue&type=style&index=0&id=644ab108&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__